export default [
  {
    label: 'Merchant',
    value: 'merchant',
  }, {
    label: 'Category',
    value: 'category',
  },
];
